import { NextPage } from 'next'

// Meta Tags
import MetaTags from '@/components/common/meta-tags'

// BreadCrumb
import BreadCrumb from '@/components/common/breadcrumb'

// Component
import GallerySection from '@/components/page-components/gallery-page'

const GalleryPage: NextPage = () => {
  return (
    <>
      <MetaTags title="Gallery | Comfort - The Home Craft" />

      <BreadCrumb pageName="Gallery" />

      <GallerySection />
    </>
  )
}

export default GalleryPage
